import React from 'react';
import { Form, Input, Button, Row, Col, Space } from 'antd';
import emiter, { EVENT_CARRENTAL_ROLE_SEARCH_LIST } from '../../../../events';
import {DEFAULT_PAGE_INFO} from "../../../../consts";
interface PropsType {
	enums?: any;
}

const SPRolePermissionsSearchForm: React.FC<PropsType> = props => {
	const searchButtonText = '搜索';
	const clearButtonText = '清空';
	const searchFormFields = {
		juese: { name: 'role_name', label: '角色', required: false, message: '请输入角色', placeholder: '请输入' },
	};

	const searchBarStyle: React.CSSProperties = { marginBottom: '20px' };

	const [searchForm] = Form.useForm();

	const onSearchFormReset = () => {
		searchForm.resetFields();
		emiter.emit(EVENT_CARRENTAL_ROLE_SEARCH_LIST, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

	const onSearchFormFinish = () => {
		emiter.emit(
			EVENT_CARRENTAL_ROLE_SEARCH_LIST,
      {
        ...searchForm.getFieldsValue(),
        ...DEFAULT_PAGE_INFO
      }
		);
	};

	return (
		<Form form={searchForm} onFinish={onSearchFormFinish}>
			<Row gutter={24}>
				<Col span={8}>
					<Form.Item
						name={searchFormFields?.juese.name}
						label={searchFormFields?.juese.label}
						rules={[
							{
								required: searchFormFields?.juese.required,
								message: searchFormFields?.juese.message,
							},
						]}
					>
						<Input placeholder={searchFormFields?.juese.placeholder} allowClear />
					</Form.Item>
				</Col>
			</Row>
			<div style={searchBarStyle}>
				<Space size="small">
					<Button type="primary" onClick={onSearchFormFinish}>
						{searchButtonText}
					</Button>
					<Button onClick={onSearchFormReset}>{clearButtonText}</Button>
				</Space>
			</div>
		</Form>
	);
};

export default SPRolePermissionsSearchForm;
